module.exports = __webpack_public_path__ + "static/media/step-2.25744ebc.gif";